$.fn.selectToDropdown = function () {
    $(this).each(function(){
        var selectEl = $(this),
            selectID = selectEl.attr('id'),
            placeHolderEl = $('.select-toggle-text'),
            placeHolderText = placeHolderEl.text();

        // Build li menu
        var menuUl = $('#' + selectID + 'Dropdown ul');
        $('#' + selectID + ' option').each(function () {
            var $this = $(this);

            var a = $(document.createElement('a'))
                .attr('href', '#')
                .attr('type', 'button')
                .addClass('dropdown-menu-item')
                .data('value', $this.val())
                .text($this.text());

            var li = $(document.createElement('li'))
                .append(a);

            menuUl.append(li);
        });

        function setToggleText(text, isSelected) {
            selectEl.siblings('.dropdown')
                .find('.select-toggle-text')
                .toggleClass('selected', isSelected)
                .html(text + (isSelected ? ' <span class="sr-only">selected</span>' : ''));
        }

        function updateMenuDisplay() {

            // Get selected option from select
            var selected = $('#' + selectID + ' option').filter(function() {
                return $(this).prop('selected');
            });

            if (!selected.length) {
                setToggleText(placeHolderText, false);
            } else {
                setToggleText(selected.text(), true);
            }

            if (selected.val() === '') {
                placeHolderEl.addClass('selected-placeholder');
            } else {
                placeHolderEl.removeClass('selected-placeholder');
            }
        }

        // Initial update
        updateMenuDisplay();

        selectEl.siblings('.dropdown').find('.dropdown-menu-item').on('click', function(e) {
            e.preventDefault();

            var value = $(this).data('value');

            // Select the correct option
            $('#' + selectID + ' option').prop('selected', false);

            var optionToSelect = $('#' + selectID + ' option').filter(function() {
                return $(this).val() === value;
            });

            optionToSelect.prop('selected', true);

            // Update after click
            updateMenuDisplay();
        });
    });
};
